import { _adr } from "../../../../address";
import MainLayout from "../../../layouts/layout";
import { HomeOutlined } from "@ant-design/icons";
import "../sp.scss";
import "./spkit.scss";
import { Breadcrumb, Button, Col, Form, Input, Row, Steps, Switch, message } from "antd";
import { Content } from "antd/es/layout/layout";
import { useTranslation } from "react-i18next";
import { useDealer } from "../../../../tools/api";

import { convertPersian, isEmpty, validateInput } from "../../../../tools/tools";
import SearchMsisdnBundle from "./searchMsisdnBundle";
import BundleList from "./bundle";
import React, { Fragment, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearFormData } from "../../../../reducer/serviceReducer";
import SPShopLayout from "../sp-shop-layout";
import ScanBarCode from "../../../auxiliary/scanbarcode/ScanBarCode";
import { switchPlanID } from "../../../../tools/services";
import { bundlesJsonTest } from "../../../../json/bundles.json";

const SPKit = () => {
	//#region Hooks Additional
	const [t] = useTranslation("global");
	const { queryBundleSalesSimByKit, validateKitNo } = useDealer();
	const formData = useSelector((state) => state);
	const dispatch = useDispatch();
	//#endregion Hooks Additional
	const [messageApi, contextHolder] = message.useMessage();
	const location = useLocation();

	const [frmBundle] = Form.useForm();

	//#region statements

	//Progress On ValidKKit
	const [isProgress, setIsProgress] = useState(false);
	//Check exist Bundle
	const [isValidBundle, setIsValidBundle] = useState(false);

	//show Special Search MSISDN
	const [isShowBoxSearch, setIsShowBoxSearch] = useState(false);

	//bundle list
	const [bundles, setBundle] = useState([]);

	//msisdn assign the bundle
	const [msisdnBundle, setMsisdnBundle] = useState([]);

	//kit for Bundle
	const [kitBundle, setKitBundle] = useState(location?.state?.kit || "");

	const [openBarCode, setOpenBarCode] = useState(false);

	//iccid sate
	const [iccid, setIccid] = useState("");

	//#endregion statements

	useEffect(() => {}, []);

	const handleSubmit = async (param) => {
		dispatch(clearFormData(["spPurchase"]));
		setIsProgress(true);
		setKitBundle(param.kit);
		let payload = {
			kitno: param.kit,
		};
		let resValid = await validateKitNo(payload);
		if (resValid) {
			setIccid(resValid?.iccid);
			payload = {
				kitno: param.kit,
				planid: switchPlanID().simPurchase,
			};
			let response = await queryBundleSalesSimByKit(payload);

			// let response = bundlesJsonTest;

			//check has Item
			if (response?.bundle.length > 0 || response?.spBundle?.length > 0) {
				setIsValidBundle(true);

				//check has Item spBundle
				// let resultCatID = [];
				// response.spBundle.forEach((element) => {
				// 	let matchItem = resultCatID.filter((item) => item.bundleSalesSimId === element.bundleSalesSimId);
				// 	if (matchItem.length === 0) {
				// 		resultCatID.push(element);
				// 	}
				// });
				// resultCatID = resultCatID.map((bundle) => {
				// 	return {
				// 		...bundle,
				// 		attribute: response.spBundle.filter((item) => bundle.bundleSalesSimId === item.bundleSalesSimId),
				// 	};
				// });
				// resultCatID = resultCatID.sort((_a, _b) => {
				// 	_a.attribute.sort((a, b) => (a.attributeOrderId > b.attributeOrderId ? 1 : -1));
				// 	return _a.bundleOrder > _b.bundleOrder ? 1 : -1;
				// });

				// resultCatID = resultCatID.sort((a, b) => {
				// 	if (a.attributeOrderId > b.attributeOrderId) return 1;
				// 	else return -1;
				// });
				// resultCatID = resultCatID.sort((a, b) => {
				// 	if (a.bundleOrder > b.bundleOrder) return 1;
				// 	else return -1;
				// });

				//setBundle(resultCatID);

				const bundleMap = {};

				// Step 1: Group by bundleSalesSimId
				response?.spBundle?.forEach((bundle) => {
					const key = bundle.bundleSalesSimId;

					if (!bundleMap[key]) {
						bundleMap[key] = [];
					}
					bundleMap[key].push(bundle);
				});

				// Step 2: Determine parent and children in each group
				let processedBundles = Object.values(bundleMap).map((group) => {
					// Sort group by attributeOrderId to find the parent
					group.sort((a, b) => a.attributeOrderId - b.attributeOrderId);

					// First element after sorting is the parent
					const parent = { ...group[0], attribute: [] };

					// Add the remaining elements as children
					const children = group.slice(1);
					parent.attribute = children;

					return parent;
				});

				processedBundles = processedBundles?.sort((a, b) => a.bundleOrder - b.bundleOrder);

				setBundle(processedBundles);

				let msisdnList =
					response?.bundle.filter((item) => item.inT_MSISDN > 0).length > 0 ? response?.bundle.filter((item) => item.inT_MSISDN > 0) : [];
				setMsisdnBundle(msisdnList);
			} else {
				messageApi.open({
					type: "error",
					content: "رکوردی برای نمایش وجود ندارد",
				});
			}
		} else {
			setBundle([]);
			setMsisdnBundle([]);
			setIsValidBundle(false);
		}
		setIsProgress(false);
		setIsShowBoxSearch(false);
	};

	const getKitHandler = (value) => {
		if (value) {
			setOpenBarCode(false);
			frmBundle.setFieldValue("kit", value);
			setKitBundle(value);
		}
	};

	return (
		<>
			<SPShopLayout>
				{contextHolder}
				<div className="g-hold-title-of-page">
					<Breadcrumb
						className="breadcrumbs"
						items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("simcardpurchase.global.title") }]}
					/>
					<div className="title-page">
						<h3>{t("simcardpurchase.global.title")}</h3>
						<p></p>
					</div>
				</div>
				<div className="g-layout-content">
					<Content className="g-layout-main sp-container">
						<div className="g-format-page">
							<div className="g-body-format-page">
								<div className="g-format-steps">
									<div className="holder-step">
										<Steps
											size="small"
											className="step-wizard"
											current={0}
											items={[
												{
													title: "بسته آغازین",
												},
												{
													title: "اطلاعات هویتی",
												},
												{
													title: "پیش فاکتور",
												},
												{
													title: "سند",
												},
											]}
										/>
									</div>
								</div>
								<div className="kit-container">
									<div className="hold-kit-box">
										<h3>{t("simcardpurchase.kit.title_form")}</h3>
										<Form form={frmBundle} className="form-kit" name="frm_valid_kit" layout="vertical" onFinish={handleSubmit}>
											<Row gutter={30}>
												<Col>
													{" "}
													<Form.Item
														className="input-normal"
														name="kit"
														rules={[validateInput({ t: t, validate: true, type: "number" })]}
														label={t("simcardpurchase.kit.label_input")}
														extra={
															<>
																{msisdnBundle.length > 0 && (
																	<div className="holder-result">
																		<p>
																			شماره کیت متعلق به شماره موبایل
																			{msisdnBundle.map((item, key) =>
																				key === 0 ? (
																					<React.Fragment key={key}>
																						<span dir="ltr"> {item.inT_MSISDN} </span>
																					</React.Fragment>
																				) : (
																					<React.Fragment key={key}>
																						<span key={key} dir="ltr">
																							{" "}
																							{item.inT_MSISDN}{" "}
																						</span>
																						{" ,"}
																					</React.Fragment>
																				),
																			)}
																			می‌باشد
																		</p>
																	</div>
																)}
															</>
														}>
														<Input
															dir="ltr"
															placeholder={t("simcardpurchase.kit.placehoder_input_kit")}
															inputMode="numeric"
															maxLength={9}
															onChange={(e) => {
																e.target.value = convertPersian(e.target.value);
															}}
															showCount
														/>
													</Form.Item>
												</Col>
												<Col>
													<Form.Item label={<>&nbsp;</>}>
														<Button className="btn-normal btn-green" onClick={() => setOpenBarCode(true)}>
															اسکن بارکد
														</Button>
														<ScanBarCode isOpen={openBarCode} value={getKitHandler} />
													</Form.Item>
												</Col>
												<Col>
													<Form.Item label={<>&nbsp;</>}>
														<Button className="btn-normal btn-green" type="default" disabled={isProgress} htmlType="submit">
															{isProgress ? t("form.inProgress") : t("simcardpurchase.kit.buttonKitValid")}
														</Button>
													</Form.Item>
												</Col>
											</Row>
										</Form>

										{isValidBundle && (
											<>
												<div className="hold-opration">
													{msisdnBundle.length === 0 && (
														<div className="holder-checked">
															<div className="row-checked">
																<div className="label-hold">
																	<label htmlFor="">شماره خاص می خواهم</label>
																</div>
																<div className="checked-hold">
																	<Switch
																		size="small"
																		className="switcherOpration"
																		defaultChecked={isShowBoxSearch}
																		checked={isShowBoxSearch}
																		onChange={() => {
																			setIsShowBoxSearch((prev) => !prev);
																		}}
																	/>
																</div>
															</div>
														</div>
													)}

													{isShowBoxSearch && <SearchMsisdnBundle iccid={iccid} kitbundle={kitBundle} />}
													{!isShowBoxSearch && (
														<div className="g-list-bundle">
															<BundleList
																iccid={iccid}
																bundles={bundles}
																kitbundle={kitBundle}
																msisdn={msisdnBundle.map((item) => item.inT_MSISDN)}
															/>
														</div>
													)}
												</div>
											</>
										)}
									</div>
								</div>
							</div>
						</div>
					</Content>
				</div>
			</SPShopLayout>
		</>
	);
};

export default SPKit;
